import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import HomePage from './HomePage';
import AdvancedProgram from './AdvancedProgram';
import FreeProgram from './FreeProgram';
import Testimonials from './Testimonials';
import Store from './Store';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/programa-gratuito" element={<FreeProgram />} />
          <Route path="/programa-avanzado" element={<AdvancedProgram />} />
          <Route path="/testimonios" element={<Testimonials />} />
          <Route path="/tienda" element={<Store />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;